







































import { Component, Inject, Vue } from "vue-property-decorator";
import { ITicketsProvider } from "@/models/providers/tickets";
@Component({
  components: {
    "tickets-inbox-skeleton": () =>
      import("@/components/app/global/tickets/ticketsInboxSkeleton.vue"),
    "inbox-list-item": () =>
      import("@/components/app/global/tickets/inboxListItem.vue")
  }
})
export default class TicketsInboxList extends Vue {
  // Inject
  @Inject({ from: "ticketsProvider" })
  public readonly $ticketsProvider!: () => ITicketsProvider;
  // Computed
  public get ticketsProvider() {
    return this.$ticketsProvider();
  }
  public get isEmptyInbox() {
    return !this.ticketsProvider.isLoading && !this.ticketsProvider.total;
  }
}
